import React from 'react';
import { Select, Tooltip } from '@rendering/components';
import { LETTERPRESS_DEPTHS, LETTERPRESS_MODE_SOFTLIGHT, LETTERPRESS_MODES_OPTIONS } from 'src/config/constants';
import { LetterPressEffect } from 'src/config/effects';
import { SelectEvent } from 'src/types';

interface LetterPressViewProps {
    id: string;
    effect: LetterPressEffect;
    updateEffectProperty: (data: { id: string; property: string; value: any }) => void;
}

const LetterPressView = (props: LetterPressViewProps) => {
    const { id, effect, updateEffectProperty } = props;
    return (
        <div className='letterpress-settings'>
            <h3>
                Letter Press Settings{' '}
                <Tooltip
                    contents='Letter Press is a printing technique that creates a debossed effect on the paper. It
                                involves pressing an inked plate onto the paper, resulting in a tactile and visually
                                appealing design. This technique is often used for wedding invitations, business cards,
                                and other high-end printed materials.'>
                    <img
                        src='https://static.ux.cimpress.io/assets/icons/help-circle-f.svg'
                        alt='Help about Letter Press'
                    />
                </Tooltip>
            </h3>
            <Select
                label='Choose Mode'
                value={{
                    value: effect.mode,
                    label: effect.mode === LETTERPRESS_MODE_SOFTLIGHT ? 'Softlight' : 'Overlay',
                }}
                className='letterpress-mode-select'
                options={LETTERPRESS_MODES_OPTIONS}
                onChange={(e: SelectEvent) => updateEffectProperty({ id, property: 'mode', value: e.value })}
                isClearable={false}
                isSearchable={false}
            />
            <Select
                label='Choose Depth'
                value={{ value: effect.depth, label: `${effect.depth}` }}
                className='letterpress-depth-select'
                options={LETTERPRESS_DEPTHS}
                onChange={(e: SelectEvent) => updateEffectProperty({ id, property: 'depth', value: e.value })}
                isClearable={false}
                isSearchable={false}
            />
        </div>
    );
};

export default LetterPressView;
